






































































































































































































































































































































import Vue from 'vue';
import moment from 'moment';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { TransitTimeStat } from '@/models/admin/TransitTimeStat';

import localStorageService from '@/services/LocalStorageService';
import transitTimeService from '@/services/TransitTimeService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      loading: false,
      term: '',
      comparisonPopup: false,
      stats: [] as TransitTimeStat[],
      filteredStats: [] as TransitTimeStat[],
      groups: [] as TransitTimeStat[][],
      selectedGroups: [] as TransitTimeStat[][],
      selectedTimeSlot: {
        text: '30 days',
        value: 30,
      },
      timeSlots: [
        {
          text: '7 days',
          value: 7,
        },
        {
          text: '30 days',
          value: 30,
        },
        {
          text: '1 year',
          value: 365,
        },
        {
          text: 'All time',
          value: 365 * 2,
        },
      ],
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    backToPrevPage() {
      history.back();
    },
    fetch() {
      this.loading = true;
      transitTimeService
        .getStatsByAccountId(this.client.id, 730)
        .then((x: TransitTimeStat[]) => {
          this.stats = x;
          this.filteredStats = x;

          this.applyFilters();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    applyFilters() {
      this.filteredStats = this.stats.filter(
        (x) =>
          moment(x.dateCreated) >=
          moment().subtract(this.selectedTimeSlot.value, 'days')
      );

      // Group the data by carrierName and scac
      const groups = {};
      this.filteredStats.forEach((stat) => {
        const key = `${stat.carrierName}_${stat.scac}`;
        if (!groups[key]) {
          groups[key] = {
            carrierName: stat.carrierName,
            scac: stat.scac,
            estTransDays: [],
            actTransDays: [],
          };
        }
        groups[key].estTransDays.push(stat.estTransDays);
        groups[key].actTransDays.push(stat.actTransDays);
      });

      // Calculate the average estTransDays and actTransDays for each group
      Object.keys(groups).forEach((key) => {
        const group = groups[key];
        const estTransDaysSum = group.estTransDays.reduce((a, b) => a + b, 0);
        const actTransDaysSum = group.actTransDays.reduce((a, b) => a + b, 0);
        group.estTransDays =
          Math.round((estTransDaysSum / group.estTransDays.length) * 100) / 100;
        group.actTransDays =
          Math.round((actTransDaysSum / group.actTransDays.length) * 100) / 100;
      });

      this.groups = Object.values(groups);
      this.selectedGroups = this.groups;
    },
    basedOn(scac) {
      return this.filteredStats.filter((x) => x.scac === scac).length;
    },
    removeGroupFromSelected(scac) {
      this.selectedGroups = this.selectedGroups.filter((x) => x.scac !== scac);
    },
    filterCarriers() {
      console.log(this.term);
    },
    showAdd(scac) {
      return this.selectedGroups.filter((x) => x.scac === scac).length === 0;
    },
    add(scac) {
      const group = this.groups.find((x) => x.scac === scac);
      this.selectedGroups.push(group);
    },
    remove(scac) {
      this.selectedGroups = this.selectedGroups.filter((x) => x.scac !== scac);
    },
  },
  computed: {
    pageHeader() {
      return `${this.client?.company}’s Transit-Time-Comparative Graph`;
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    maxEstTransDays() {
      return Math.max(...this.groups.map((x) => x.estTransDays));
    },
    maxActTransDays() {
      return Math.max(...this.groups.map((x) => x.actTransDays));
    },
    days() {
      const arr = [];
      const max = Math.max(this.maxEstTransDays, this.maxActTransDays);
      const limit = max > 20 ? 20 : max;
      for (let i = 0; i <= limit; i++) {
        arr.push(i);
      }
      return arr;
    },
    backToLbl() {
      return document.referrer?.includes('/dashboard')
        ? 'Back to Dashboard'
        : 'Back to Clients';
    },
  },
});
